export default "__VITE_ASSET__B$MOu6c8__"